import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SidebarComponent from "./SidebarComponent.vue";
import { onMounted, reactive } from "vue";
import { getAvailableRoutes } from "@/service/user.service";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";
import securityService from "@/service/security.service";
import { AppType } from "@/types/app.type";
import { MenuItem } from "@/types/menuItem.type";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const items = reactive<MenuItem[]>([
  {
    icon: "el-icon el-icon-home fas",
    index: "/process-tracking", // Ahora apunta correctamente a Home.view.vue
    title: "menu.home",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-eye fas",
    index: "/process-tracking/samplingpoints",
    title: "menu.samplingPoints",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-file-export fas",
    index: "/stations/new",
    title: "menu.new",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-upload fas",
    index: "/process-tracking/upload",
    title: "menu.uploaderData",
    disabled: false,
    subs: [
      {
        icon: "",
        index: "/process-tracking/upload",
        title: "menu.uploaderData",
        disabled: false,
      },
      {
        icon: "",
        index: "/process-tracking/trainingdata",
        title: "menu.trainingData",
        disabled: false,
      },
      {
        index: "/process-tracking/uploadCsv",
        title: "menu.csv",
        disabled: false,
      },
    ],
  },
  {
    icon: "el-icon el-icon-download fas",
    index: "",
    title: "menu.downloadData",
    disabled: false,
    subs: [
      {
        icon: "",
        index: "/process-tracking/downloadTrainingData",
        title: "menu.trainingData",
        disabled: false,
      },
    ],
  },
  {
    icon: "el-icon el-icon-sort fas",
    title: "menu.dayOrNight",
    disabled: false,
    index: "/process-tracking/dayOrNightLabelling",
  },
]);

const store = useStore<RootState>();

onMounted(async () => {
  const canAdmin = securityService.canAccessToApp(AppType.ADMIN);
  const canSupport = securityService.canAccessToApp(AppType.SUPPORT);
  const canStations = securityService.canAccessToApp(AppType.STATIONS);
  const canProcessTracking = securityService.canAccessToApp(AppType.PROCESS_TRACKING);
  const canAccessIssueMonitoring = securityService.canAccessToApp(AppType.ISSUE_MONITORING);

  if (canProcessTracking && !canSupport && !canStations && !canAdmin && !canAccessIssueMonitoring) {
    items.shift();
  }
  if (store.state.auth.user?.id) {
    let userRoutes = await getAvailableRoutes(store.state.auth.user.id);

    if (userRoutes && Array.isArray(userRoutes) && userRoutes.length > 0) {
      items.forEach((item: MenuItem) => {
        item.disabled = !userRoutes.includes(item.index);
      });
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SidebarComponent, { items: _unref(items) }, null, 8, ["items"]))
}
}

})